<template>
	<div>
		<footer class="container-fluid mt-5 py-4">
			<div class="container">
				<div class="row">
					<div class="footer_logo col-12">
						<img src="/images/k1stlogo_color-8.png" class="float-left">
						<div class="canClick float-right">
							<a href="https://twitter.com/k1stshop"><img class="sns_icon twitter" src="/images/logo-x.png"></a>
						</div>
					</div>
				</div>
				<div class="row mt-3">
					<nav class="footer col-12 pr-5 row">
						<div class="nav-footer center col-12">
							<ul class="nav">
								<li class="nav-item px-2">
									<a :href="cart+'/v2/help/help.aspx?ccode=K1ST'">ヘルプ</a>
								</li>
								<li class="nav-item px-2">
									<a :href="cart+'/v2/help/contact.aspx?ccode=K1ST'">お問い合わせ</a>
								</li>
								<li class="nav-item px-2">
									<a :href="cart+'/v2/help/tokutei.aspx?ccode=K1ST'">特定商取引法</a>
								</li>
								<li class="nav-item px-2">
									<a :href="cart+'/v2/help/kiyaku.aspx?ccode=K1ST'">利用規約</a>
								</li>
								<li class="nav-item px-2">
									<a :href="cart+'/v2/help/privacy.aspx?ccode=K1ST'">プライバシーポリシー</a>
								</li>
							</ul>
						</div>
						<div class="col-12 text-left copy">
							© SM ENTERTAINMENT JAPAN
						</div>
					</nav>
				</div>
			</div>

		</footer>

		<span id="top-link-block" class="d-block position-fixed" @click="top()">
			<a class="btn btn-color2">
				<i class="fas fa-angle-up"></i>
			</a>
		</span>
	</div>
</template>

<style>
	.copy{
		margin: 5% 0 0;
		font-size: 0.7rem;
	}
	@media(min-width: 576px){
		.sns div{
			padding-top: 3%;
		}
		.sns img{
			width: 70%;
		}
	}
	@media(min-width: 768px){
		.sns img{
			width: 70%;
		}
	}
	@media(min-width: 1024px){
		.sns img{
			width: 55%;
		}
	}

</style>

<script>
	export default{
		data(){
			return{
				cart:process.env.VUE_APP_CARTURI,
			}
		},
		methods:{
			top(){
				scrollTo({
					top:0,
					behavior:"smooth"
				});
			}
		}
	}
</script>